import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

export type IResyncObjectRepoResponse = IRepoResponse<200> | IRepoResponse<400 | 500, string>;

export type IResyncObjectRepo = IRepo<[string | number], IResyncObjectRepoResponse>;

export const ResyncObjectRepoType = Symbol.for('ResyncObjectRepoType');

@bind(ResyncObjectRepoType)
export class ResyncObjectRepo implements IResyncObjectRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(object_id: string | number) {
    try {
      const result = await this.httpClient.post({ url: urlMaker(`/objects/${object_id}/re-sync`) });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else {
        return {
          status: 400 as 400,
          response: result.data.errors.map((error) => Object.values(error).join('. ')).join('. ') || 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
